export default "e027f8c96cc97896.svg"